import classes from "./Footer.module.css";

const Footer = () => {
  return <div className={classes.footer}>Made With ❤️ By Juan Caimen</div>;
};

export default Footer;
